import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Modal, Image } from "react-bootstrap";
import * as wjCore from "wijmo/wijmo";
import api from "../../config/api";
import config from "../../config/config";
import { connect } from "react-redux";

// views
import DashboardSpaceModal from "./dashboard_space_modal";
import DashboardWaterModal from "./dashboard_water_modal";
import DashboardWidgetModal from "./dashboard_widget_modal";
import DashboardBlk from "./dashboard_blk";
import StatsBlk from "../../components/liveStatsBlk";
import BlankBlk from "../../components/blankBlk";
import LoadingModal from "../../components/loadingModal";

// css
import "./dashboard.css";

function Dashboard(props) {
  function splitArr(arr) {
    let bigArr = [[], [], []];
    let count = 0;

    for (let i = 0; i < arr.length; i++) {
      bigArr[count].push(arr[i]);
      if (count === 2) {
        count = 0;
      } else {
        count += 1;
      }
    }

    return { arr: bigArr, count: count };
  }

  let theme = localStorage.getItem("theme");
  const [dashConfig, setDashConfig] = useState([]);
  const isInitialRender = useRef(true);
  const shouldUpdateSettings = useRef(true);

  const { GET_DASHBOARD_DATA, GET_NOTIFICATION_DATA, SET_DASHBOARD_SETTING } =
    config.api_endpoint;
  const [selected_tile, setSelectedTile] = useState("");
  const [showTile, setShowTile] = useState(false);
  const [colA, setColA] = useState([]);
  const [colB, setColB] = useState([]);
  const [colC, setColC] = useState([]);
  const [blankShouldBeHere, setBlankShouldBeHere] = useState(0);
  const [tiles, setTiles] = useState([]);
  const [liveData, setLiveData] = useState({ room_list: [] });
  const [tileMainData, setTileMainData] = useState({});

  // kaer air space blocks
  const [spaceCats, setSpaceCats] = useState(["Main"]);
  const [spaceFloors, setSpaceFloors] = useState(["All"]);
  const [spaceTypes, setSpaceTypes] = useState(["All"]);

  const [showSpaceDialog, setShowSpaceDialog] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedSpaceFloor, setSelectedSpaceFloor] = useState("All");
  const [selectedSpaceType, setSelectedSpaceType] = useState("All");
  const [selectedSpaceCat, setSelectedSpaceCat] = useState("Main");
  const [spaceBlocks, setSpaceBlocks] = useState([]);
  const [spaceClickedFrom, setSpaceClickedFrom] = useState("");
  const [airDialogClickedFrom, setAirDialogClickedFrom] = useState("");
  const [airDialogWidget, setAirDialogWidget] = useState("");
  const [loading, setLoading] = useState(false);

  // kaer water blocks
  const [selectedWaterBlock, setSelectedWaterBlock] = useState("");
  const [showWaterSpaceDialog, setShowWaterSpaceDialog] = useState(false);
  const [waterDialogWidget, setWaterDialogWidget] = useState("");
  const [waterDialogClickedFrom, setWaterDialogClickedFrom] = useState("");
  const [waterSpaceBlocks, setWaterSpaceBlocks] = useState([]);
  const [selectedWaterSpace, setSelectedWaterSpace] = useState("");

  const pauseSetInternval = useRef(false);

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  currentDate =
    currentDate.getFullYear() +
    "-" +
    (currentDate.getMonth() + 1) +
    "-" +
    currentDate.getDate();

  let from_ts = currentDate;
  let to_ts = currentDate;
  const [selectedDataRange, setSelectedDataRange] = useState("Previous Day");

  const { AuthDetail, AuthLoggedIn, CSRFToken } = props;
  let dashboardInterval = null;

  let all_available_resource_types = {
    equipment_and_operations: "Equipment & operations",
    "as-built_drawings": "As-built drawings",
    maintenance_and_water_reports: "Maintenance & Water reports",
    cooling_tower_information: "Cooling tower information",
    iaq_reports: "IAQ reports",
  };

  const getCurrentSite = config.getCurrentSite;

  const calculateIndicatorDeg = (tmp, max) => {
    let per = (180 / max) * tmp;
    return parseInt(per);
  };

  const getDateRangeForData = (range) => {
    let current = new Date();
    let fromDate = "";
    let toDate = "";

    if (range === "day") {
      let tmp = new Date();
      tmp.setDate(current.getDate() - 1);
      fromDate =
        tmp.getFullYear() + "-" + (tmp.getMonth() + 1) + "-" + tmp.getDate();
      toDate =
        tmp.getFullYear() + "-" + (tmp.getMonth() + 1) + "-" + tmp.getDate();
      setSelectedDataRange("Previous Day");
    } else if (range === "week") {
      let tmp = new Date();
      tmp.setDate(current.getDate() - 1);
      let tmp2 = new Date();
      tmp2.setDate(current.getDate() - 7);
      fromDate =
        tmp2.getFullYear() + "-" + (tmp2.getMonth() + 1) + "-" + tmp2.getDate();
      toDate =
        tmp.getFullYear() + "-" + (tmp.getMonth() + 1) + "-" + tmp.getDate();
      setSelectedDataRange("Previous Week");
    } else if (range === "month") {
      let tmp = new Date();
      tmp.setDate(current.getDate() - 1);
      let tmp2 = new Date();
      tmp2.setDate(current.getDate() - 30);
      fromDate =
        tmp2.getFullYear() + "-" + (tmp2.getMonth() + 1) + "-" + tmp2.getDate();
      toDate =
        tmp.getFullYear() + "-" + (tmp.getMonth() + 1) + "-" + tmp.getDate();
      setSelectedDataRange("Previous Month");
    } else if (range === "year") {
      let tmp = new Date();
      tmp.setDate(current.getDate() - 1);
      let tmp2 = new Date();
      tmp2.setDate(current.getDate() - 365);
      fromDate =
        tmp2.getFullYear() + "-" + (tmp2.getMonth() + 1) + "-" + tmp2.getDate();
      toDate =
        tmp.getFullYear() + "-" + (tmp.getMonth() + 1) + "-" + tmp.getDate();
      setSelectedDataRange("Previous Year");
    }

    return { from: fromDate, to: toDate };
  };

  const resoChoiceClicked = (event) => {
    event.preventDefault();
    let choice = event.target.getAttribute("data-choice").trim();
    let relatedData = tileMainData["resources"][choice];
    let choiceElement =
      event.target.closest("ul").previousSibling.previousSibling;
    let id = choiceElement.id.replace("reso_", "");

    console.log(
      "=== resoChoiceClicked === ",
      id,
      choice,
      all_available_resource_types[choice]
    );

    let tmpTiles = tiles.slice();
    let pointer = 0;

    tmpTiles.forEach(function (item, index) {
      if (item["id"] == id) {
        tmpTiles[index]["data"] = relatedData;
        tmpTiles[index]["chosen_text"] = all_available_resource_types[choice];
        tmpTiles[index]["chosen_type"] = choice;
        // React render will reflect updated chosen_text; avoid direct DOM manipulation

        pointer = index;
      }
    });

    pointer = pointer + 1;

    shouldUpdateSettings.current = true;

    let tmpDashConfig = dashConfig.slice();
    tmpDashConfig[pointer]["selected"] = choice;
    setDashConfig(tmpDashConfig);

    setTiles(tmpTiles);
    let tmp = splitArr(tmpTiles);
    setColA(tmp["arr"][0]);
    setColB(tmp["arr"][1]);
    setColC(tmp["arr"][2]);
    setBlankShouldBeHere(tmp["count"]);
  };

  const dataChoiceClicked = (event) => {
    event.preventDefault();
    let choice = event.target.getAttribute("data-choice").trim();
    let relatedData = tileMainData["data"][choice];
    let choiceElement =
      event.target.closest("ul").previousSibling.previousSibling;
    let id = choiceElement.id.replace("data_", "");

    // console.log("current text: ", document.getElementById("data_" + id).innerText, choice.charAt(0).toUpperCase() + choice.slice(1));
    // console.log("choiceElement: ", choice, choiceElement, id, relatedData);
    // console.log("new text: ", "Previous " + choice.charAt(0).toUpperCase() + choice.slice(1));

    let tmpTiles = tiles.slice();
    let pointer = 0;

    tmpTiles.forEach(function (item, index) {
      if (item["id"] == id) {
        tmpTiles[index]["data"] = relatedData;
        tmpTiles[index]["chosen_date"] =
          "Previous " + choice.charAt(0).toUpperCase() + choice.slice(1);
        // React render will reflect updated data; avoid direct DOM manipulation

        pointer = index;
      }
    });

    pointer = pointer + 1;

    shouldUpdateSettings.current = true;

    let tmpDashConfig = dashConfig.slice();
    tmpDashConfig[pointer]["selected"] = choice;
    setDashConfig(tmpDashConfig);

    setTiles(tmpTiles);
    let tmp = splitArr(tmpTiles);
    setColA(tmp["arr"][0]);
    setColB(tmp["arr"][1]);
    setColC(tmp["arr"][2]);
    setBlankShouldBeHere(tmp["count"]);
  };

  const readNotification = (event) => {
    let id = event.target.getAttribute("data-id");

    if (id.includes(",")) {
      id = id.split(",");
    }

    setLoading(true);
    api
      .post(GET_NOTIFICATION_DATA, JSON.stringify({ noti_id: id }), CSRFToken)
      .then((res) => {
        console.log("Dashboard notification read: ", res);
        setLoading(false);
        loadDashboardData();
      })
      .catch((err) => {
        console.log("Dashboard notification read err", err);
        setLoading(false);
      });
  };

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // event

  /*
      Processing when the icon is clicked in widget selection modal
  */
  const handleClose = (clicked) => {
    shouldUpdateSettings.current = true;

    if (clicked === "data") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Data",
          tile_heading: "Data",
          chart_type: "",
          chart_title: "",
          chosen_date:
            "Previous " + "day".charAt(0).toUpperCase() + "day".slice(1),
          data: tileMainData["data"]["day"],
        },
      ]);

      setDashConfig([...dashConfig, { name: "data", selected: "day" }]);
    } else if (clicked === "live") {
      let live_data = {
        power: "-",
        temp: 0,
        cooling: 0,
        min_cooling: 150,
        max_cooling: 2200,
        confer_temp: 0,
        water: 0,
      };

      if (tileMainData["live_kw"] && tileMainData["live_ka"]) {
        live_data["power"] = tileMainData["live_kw"]["system_status"];
        live_data["temp"] = tileMainData["live_kw"]["water_temp"];
        live_data["cooling"] = tileMainData["live_kw"]["cooling_amount"];
        live_data["rooms"] = [];
        live_data["confer_temp"] = "-";
        live_data["water"] = "-";
        live_data["chosen_room"] = "-";
      }

      if (tileMainData["live_ka"]["rooms"].length > 0) {
        live_data["chosen_room"] = tileMainData["live_ka"]["rooms"][0]["name"];
        live_data["rooms"] = tileMainData["live_ka"]["rooms"];
        live_data["confer_temp"] =
          tileMainData["live_ka"]["rooms"][0]["temperature"];
        live_data["water"] = tileMainData["live_ka"]["rooms"][0]["humidity"];
      }

      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Live",
          tile_heading: "Live - Kaer Air",
          chart_type: "",
          chart_title: "",
          data: live_data,
          selected: tileMainData["live_ka"]["rooms"][0]["name"],
        },
      ]);

      setDashConfig([
        ...dashConfig,
        { name: "live", selected: tileMainData["live_ka"]["rooms"][0]["name"] },
      ]);
    } else if (clicked === "notifications") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Notification",
          tile_heading: "Notifications",
          chart_type: "",
          chart_title: "Clear All",
          data: tileMainData["notifications"],
          readNotification: readNotification,
        },
      ]);

      setDashConfig([...dashConfig, { name: "notification", selected: "" }]);
    } else if (clicked === "contact") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Contact",
          tile_heading: "Contact",
          chart_type: "",
          chart_title: "",
          data: tileMainData["contacts"],
        },
      ]);

      setDashConfig([...dashConfig, { name: "contact", selected: "" }]);
    } else if (clicked === "billing") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Billing",
          tile_heading: "Billing",
          chart_type: "",
          chart_title: "",
          data: tileMainData["invoices"],
        },
      ]);

      setDashConfig([...dashConfig, { name: "billing", selected: "" }]);
    } else if (clicked === "profile") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Profile",
          tile_heading: "Profile",
          chart_type: "",
          chart_title: "",
          data: tileMainData["profile"],
        },
      ]);

      setDashConfig([...dashConfig, { name: "profile", selected: "" }]);
    } else if (clicked === "resource") {
      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Resource",
          tile_heading: "Resources",
          chart_type: "",
          chart_title: "",
          chosen_type: "equipment_and_operations",
          chosen_text: "Equipment & operations",
          data: tileMainData["resources"]["equipment_and_operations"],
        },
      ]);

      setDashConfig([
        ...dashConfig,
        { name: "resource", selected: "equipment_and_operations" },
      ]);
    } else if (clicked === "chilled_water_supply") {
      let live_data = { ...liveData };

      if (tileMainData["live_ka"]["rooms"].length > 0) {
        live_data["selected_kw"] = tileMainData["live_kw_data"]["rooms"][0];
        live_data["kw_rooms"] = tileMainData["live_kw_data"]["rooms"];
      }

      setTiles([
        ...tiles,
        {
          id: Math.floor(Math.random() * 1000 + 1),
          tile_type: "Chilled water supply",
          tile_heading: "Live - Kaer Water",
          chart_type: "",
          chart_title: "",
          data: live_data,
          selected: live_data["selected_kw"],
        },
      ]);

      setDashConfig([
        ...dashConfig,
        {
          name: "chilled_water_supply",
          selected: live_data["selected_kw"]
            ? live_data["selected_kw"]["name"]
            : "",
        },
      ]);
    }

    let tmp = splitArr(tiles);
    setColA(tmp["arr"][0]);
    setColB(tmp["arr"][1]);
    setColC(tmp["arr"][2]);
    setBlankShouldBeHere(tmp["count"]);

    setSelectedTile("");
    setShowTile(false);
  };

  const handleShow = () => {
    setSelectedTile("");
    setShowTile(true);
  };

  /*
      When the icon is clicked in widget selection modal
  */
  const menuClicked = (event) => {
    let clicked = event.target.getAttribute("data-menu");

    if (clicked) {
      setSelectedTile(clicked);
      handleClose(clicked);
    }
  };

  /*
      When the close icon is clicked on dashboard
  */
  const removeWidgetClicked = (event) => {
    event.preventDefault();
    let widgetID = parseInt(event.target.getAttribute("data-id"));
    let tmpTiles = tiles.slice();
    shouldUpdateSettings.current = true;

    tmpTiles.forEach(function (item, index) {
      if (item["id"] === widgetID) {
        tmpTiles.splice(index, 1);
        setTiles(tmpTiles);

        let tmpDashConfig = dashConfig.slice();
        tmpDashConfig.splice(index + 1, 1);
        setDashConfig(tmpDashConfig);
      }
    });
  };

  const getIndex = (e) => {
    const p = e.parentElement;
    for (let i = 0; i < p.children.length; i++) {
      if (p.children[i] === e) return i;
    }
    return -1;
  };

  const getColArr = (arr, str) => {
    if (str === "colA") {
      return arr[0];
    } else if (str === "colB") {
      return arr[1];
    } else {
      return arr[2];
    }
  };

  const setColArr = (str, arr, mainArr) => {
    if (str === "colA") {
      mainArr[0] = arr;
    } else if (str === "colB") {
      mainArr[1] = arr;
    } else {
      mainArr[2] = arr;
    }
  };

  const concatColArr = (arr) => {
    let tmp = [];
    for (let i = 0; i < arr[0].length; i++) {
      tmp.push(arr[0][i]);
      if (i < arr[1].length) {
        tmp.push(arr[1][i]);
      }
      if (i < arr[2].length) {
        tmp.push(arr[2][i]);
      }
    }
    return tmp;
  };

  let dragSource = null;
  let dropTarget = null;

  const dashboardDragStart = (e) => {
    console.log("dashboardDragStart e:", e);
    const target = wjCore.closest(e.target, ".tile");
    console.log("target:", target);
    if (
      target &&
      target.parentElement.parentElement ===
        document.querySelector(".dashboard")
    ) {
      dragSource = target;
      wjCore.addClass(dragSource, "drag-source");
      const dt = e.dataTransfer;
      dt.effectAllowed = "move";
      dt.setData("text", dragSource.innerHTML);
    }
  };

  const dashboardDragOver = (e) => {
    if (dragSource) {
      let tile = wjCore.closest(e.target, ".tile");
      if (tile === dragSource) {
        tile = null;
      }
      if (dragSource && tile && tile !== dragSource) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
      }
      if (dropTarget !== tile) {
        wjCore.removeClass(dropTarget, "drag-over");
        dropTarget = tile;
        wjCore.addClass(dropTarget, "drag-over");
      }
    }
  };

  const dashboardDrop = (e) => {
    if (dragSource && dropTarget) {
      // finish drag/drop
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      e.preventDefault();

      // re-order HTML elements (optional here, we're updating the state later)
      const srcIndex = getIndex(dragSource);
      const dstIndex = getIndex(dropTarget);

      let dragSourceInd = 0;
      let dropTargetInd = 0;

      let tmpTiles = tiles.slice();
      tmpTiles.forEach((item, i) => {
        if (item["id"] == dragSource.getAttribute("data-id")) {
          dragSourceInd = i;
        }
        if (item["id"] == dropTarget.getAttribute("data-id")) {
          dropTargetInd = i;
        }
      });
      let cl = tmpTiles[dragSourceInd];
      tmpTiles[dragSourceInd] = tmpTiles[dropTargetInd];
      tmpTiles[dropTargetInd] = cl;
      setTiles(tmpTiles);

      let tmpDashConfig = dashConfig.slice();
      let swapper = tmpDashConfig[dragSourceInd + 1];
      tmpDashConfig[dragSourceInd + 1] = tmpDashConfig[dropTargetInd + 1];
      tmpDashConfig[dropTargetInd + 1] = swapper;

      shouldUpdateSettings.current = true;
      setDashConfig(tmpDashConfig);

      let clone = dropTarget.cloneNode(true);
      clone.classList.remove("drag-over");

      wjCore.removeClass(dragSource, "drag-source");
      wjCore.removeClass(dropTarget, "drag-over");

      // dragSource.parentElement.insertBefore(clone, dragSource);
      // dropTarget.parentElement.insertBefore(dragSource, dropTarget);
      // dropTarget.remove();
      // dragSource.focus();
    }
  };

  const dashboardDragEnd = () => {
    wjCore.removeClass(dragSource, "drag-source");
    wjCore.removeClass(dropTarget, "drag-over");

    dragSource = dropTarget = null;

    // let dragSourceIndex = tiles
    //   .map(function (e) {
    //     return e.id;
    //   })
    //   .indexOf(parseInt(dragSource.getAttribute("data-id")));
    // let dropTargetIndex = tiles
    //   .map(function (e) {
    //     return e.id;
    //   })
    //   .indexOf(parseInt(dropTarget.getAttribute("data-id")));
    //
    // let tmpDashConfig = dashConfig.slice();
    // let swapper = tmpDashConfig[dragSourceIndex + 1];
    // tmpDashConfig[dragSourceIndex + 1] = tmpDashConfig[dropTargetIndex + 1];
    // tmpDashConfig[dropTargetIndex + 1] = swapper;
    //
    // shouldUpdateSettings.current = true;
    // setDashConfig(tmpDashConfig);
    //
    // dragSource = dropTarget = null;

    let elements = document.getElementsByClassName("liveStatsDrop");

    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener("click", showSpaceDialogClicked, false);
    }

    elements = document.getElementsByClassName("dropdown-item");

    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener("click", removeWidgetClicked, false);
    }
  };

  const addTileMouseHover = (event) => {
    let clicked = event.target.getAttribute("data-menu");

    if (clicked) {
      setSelectedTile(clicked);
    }
  };

  const addTileMouseLeave = (event) => {
    setSelectedTile("");
  };

  /* dragstart, dragover, drop, dragend
  const enableItemReorder = (panel) => {
        let dragSource = null;
        let dropTarget = null;
        // add drag/drop event listeners
        panel.addEventListener('dragstart', (e) => {
            const target = wjCore.closest(e.target, '.tile');
            if (target && target.parentElement.parentElement === panel) {
                dragSource = target;
                wjCore.addClass(dragSource, 'drag-source');
                const dt = e.dataTransfer;
                dt.effectAllowed = 'move';
                dt.setData('text', dragSource.innerHTML);
            }
        });
        panel.addEventListener('dragover', (e) => {
            if (dragSource) {
                let tile = wjCore.closest(e.target, '.tile');
                if (tile === dragSource) {
                    tile = null;
                }
                if (dragSource && tile && tile !== dragSource) {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                }
                if (dropTarget !== tile) {
                    wjCore.removeClass(dropTarget, 'drag-over');
                    dropTarget = tile;
                    wjCore.addClass(dropTarget, 'drag-over');
                }
            }
        });
        panel.addEventListener('drop', (e) => {
            if (dragSource && dropTarget) {
                // finish drag/drop
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();
                // re-order HTML elements (optional here, we're updating the state later)
                const srcIndex = getIndex(dragSource);
                const dstIndex = getIndex(dropTarget);;

                console.log("tiles: ", getTilesFromMethod(), ", srcIndex: ", srcIndex, ", dstIndex: ", dstIndex);

                const dragColName = dragSource.parentElement.getAttribute("data-col");
                const dropColName = dropTarget.parentElement.getAttribute("data-col");

                let clone = dropTarget.cloneNode(true);
                clone.classList.remove("drag-over");
                dragSource.parentElement.insertBefore(clone, dragSource);
                dropTarget.parentElement.insertBefore(dragSource, dropTarget);
                dropTarget.remove();
                dragSource.focus();

                // console.log("original tiles: ", tiles);
                // let tmpArr = splitArr(tiles)['arr'];
                // let dragCol = getColArr(tmpArr, dragColName);
                // let dropCol = getColArr(tmpArr, dropColName);
                // let tmp = dragCol[srcIndex];
                // dragCol[srcIndex] = dropCol[dstIndex];
                // dropCol[dstIndex] = tmp;
                //
                // let cols = [dragColName];
                // if (dragColName !== dropColName) {
                //   cols.push(dropColName);
                // }
                //
                // setColArr(dragColName, dragCol, tmpArr);
                // setColArr(dropColName, dropCol, tmpArr);
                // let _tiles = concatColArr(tmpArr);
                // console.log("after tiles: ", _tiles);
                // setTiles(_tiles);
            }
        });
        panel.addEventListener('dragend', () => {
            wjCore.removeClass(dragSource, 'drag-source');
            wjCore.removeClass(dropTarget, 'drag-over');
            dragSource = dropTarget = null;
        });
    };
  */

  const loadDashboardData = () => {
    setLoading(true);
    api
      .get(GET_DASHBOARD_DATA + "?site_id=" + getCurrentSite())
      .then((res) => {
        console.log("dashboard res: ", res);

        if (res["detail"] == "Authentication credentials were not provided.") {
          window.location.href = "/";
        }

        let dashSet = res["results"]["dashboard_settings"]["setting"];

        let tmp_tiles = [];
        let floors = ["All"];
        let ftypes = [];
        let cats = [];

        if (res["status"] === "Success") {
          setTileMainData(res["results"]);
          let live_data = {
            power: "-",
            temp: 0,
            cooling: 0,
            temp_limit: 0,
            min_cooling: 150,
            max_cooling: 2200,
            confer_temp: 0,
            water: 0,
            show_space_temp: res["results"]["show_space_temp"],
            show_multiple_kaer_water:
              res["results"]["show_multiple_kaer_water"],
            deg: 0,
          };

          /*
            temp_limit - is showing set-point temperature for kaer water
            max_cooling - to show on Cooling Load hover
            min_cooling - ignore
            temp - is for Chilled water supply temperature
          */

          if (res["results"]["live_kw_data"]) {
            if (res["results"]["live_kw_data"]["rooms"]) {
              live_data["selected_kw"] =
                res["results"]["live_kw_data"]["rooms"][0];
              live_data["kw_rooms"] = res["results"]["live_kw_data"]["rooms"];
              setWaterSpaceBlocks(res["results"]["live_kw_data"]["rooms"]);

              if (dashSet.length > 0) {
                if (dashSet[0]["selected_kw"]) {
                  res["results"]["live_kw_data"]["rooms"].forEach(function (
                    item,
                    index
                  ) {
                    if (
                      dashSet[0]["name"] == "main" &&
                      dashSet[0]["selected_kw"].toUpperCase() ==
                        item["name"].toUpperCase()
                    ) {
                      live_data["selected_kw"] = item;
                    }
                  });
                }
              }
            }
          }

          if (res["results"]["limit"]) {
            live_data["temp_limit"] =
              res["results"]["limit"]["chilled_water_limit"];
            live_data["min_cooling"] =
              res["results"]["limit"]["cooling_delivered_min"];
            live_data["max_cooling"] =
              res["results"]["limit"]["cooling_delivered_max"];
          }

          if (res["results"]["live_kw"] && res["results"]["live_ka"]) {
            live_data["power"] = res["results"]["live_kw"]["system_status"];
            live_data["temp"] = res["results"]["live_kw"]["water_temp"];
            live_data["cooling"] = res["results"]["live_kw"]["cooling_amount"];
            live_data["deg"] = calculateIndicatorDeg(
              live_data["cooling"],
              live_data["max_cooling"]
            );
            live_data["rooms"] = [];
            live_data["room_list"] = [];
            live_data["confer_temp"] = "-";
            live_data["water"] = "-";
            live_data["chosen_room"] = "-";
          }

          if (res["results"]["live_ka"]["rooms"].length > 0) {
            live_data["room_list"] = res["results"]["live_ka"]["room_list"];
            live_data["rooms"] = res["results"]["live_ka"]["rooms"];

            if (dashSet.length > 0) {
              if (dashSet[0]["selected"]) {
                res["results"]["live_ka"]["rooms"].forEach(function (
                  item,
                  index
                ) {
                  // console.log("NAME ==> ", dashSet[0]["name"], "Selected ==> ",  dashSet[0]["selected"], "Item Name ==> ", item["name"]);
                  if (
                    dashSet[0]["name"] == "main" &&
                    dashSet[0]["selected"].toUpperCase() ==
                      item["name"].toUpperCase()
                  ) {
                    live_data["chosen_room"] = item["name"];
                    live_data["confer_temp"] = item["temperature"];
                    live_data["water"] = item["humidity"];
                  }
                });
              }
            }
            if (live_data["chosen_room"] == "-") {
              live_data["chosen_room"] =
                res["results"]["live_ka"]["rooms"][0]["name"];
              live_data["confer_temp"] =
                res["results"]["live_ka"]["rooms"][0]["temperature"];
              live_data["water"] =
                res["results"]["live_ka"]["rooms"][0]["humidity"];
            }
          }
          setLiveData(live_data);
          setDashConfig(dashSet);

          dashSet.forEach(function (item, index) {
            if (item["name"] === "data") {
              let sel = item["selected"] || "day";
              // console.log("selected: ", sel, res["results"]["data"][sel]);

              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Data",
                tile_heading: "Data",
                chart_type: "",
                chart_title: "",
                chosen_date:
                  "Previous " + sel.charAt(0).toUpperCase() + sel.slice(1),
                data: res["results"]["data"][sel],
              });
            } else if (item["name"] === "notification") {
              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Notification",
                tile_heading: "Notifications",
                chart_type: "",
                chart_title: "Clear All",
                data: res["results"]["notifications"],
                readNotification: readNotification,
              });
            } else if (item["name"] === "contact") {
              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Contact",
                tile_heading: "Contact",
                chart_type: "",
                chart_title: "",
                data: res["results"]["contacts"],
              });
            } else if (item["name"] === "profile") {
              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Profile",
                tile_heading: "Profile",
                chart_type: "",
                chart_title: "",
                data: res["results"]["profile"],
              });
            } else if (item["name"] === "billing") {
              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Billing",
                tile_heading: "Billing",
                chart_type: "",
                chart_title: "",
                data: res["results"]["invoices"],
              });
            } else if (item["name"] === "resource") {
              let sel = item["selected"] || "equipment_and_operations";
              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Resource",
                tile_heading: "Resources",
                chart_type: "",
                chart_title: "",
                chosen_type: sel,
                chosen_text: all_available_resource_types[sel],
                data: res["results"]["resources"][sel],
              });
            } else if (item["name"] === "live") {
              let tmpLiveData = { ...live_data };
              res["results"]["live_ka"]["rooms"].forEach(function (it, ind) {
                if (item["selected"] == it["name"]) {
                  tmpLiveData["chosen_room"] = it["name"];
                  tmpLiveData["confer_temp"] = it["temperature"];
                  tmpLiveData["water"] = it["humidity"];
                }
              });

              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Live",
                tile_heading: "Live - Kaer Air",
                chart_type: "",
                chart_title: "",
                data: tmpLiveData,
              });
            } else if (item["name"] === "chilled_water_supply") {
              let tmpLiveData = { ...live_data };
              res["results"]["live_kw_data"]["rooms"].forEach(function (
                it,
                ind
              ) {
                if (item["selected"] == it["name"]) {
                  tmpLiveData["selected_kw"] = it;
                }
              });

              tmp_tiles.push({
                id: Math.floor(Math.random() * 1000 + 1),
                tile_type: "Chilled water supply",
                tile_heading: "Live - Kaer Water",
                chart_type: "",
                chart_title: "",
                data: tmpLiveData,
              });
            }
          });

          console.log("=== selectedSpaceCat === ", selectedSpaceCat);

          Object.keys(res["results"]["live_ka"]["room_map"]).forEach(function (
            key
          ) {
            if (key == selectedSpaceCat) {
              Object.keys(res["results"]["live_ka"]["room_map"][key]).forEach(
                function (key1) {
                  ftypes.push(key1);

                  Object.keys(
                    res["results"]["live_ka"]["room_map"][key][key1]
                  ).forEach(function (key2) {
                    floors.push(key2);
                  });
                }
              );
            }
          });

          ftypes = ftypes.sort();
          floors = [...new Set(floors)];
          floors.sort(
            (a, b) =>
              res["results"]["live_ka"]["floor_list"].indexOf(a) -
              res["results"]["live_ka"]["floor_list"].indexOf(b)
          );

          res["results"]["live_ka"]["building_list"].forEach((it, ind) => {
            cats.push(it);
          });

          isInitialRender.current = false;
          shouldUpdateSettings.current = false;

          setTiles(tmp_tiles);

          console.log("=== floors === ", floors);
          console.log("=== ftypes === ", ftypes);
          console.log("=== cats === ", cats);
          setSpaceFloors(floors);
          ftypes = ftypes.sort((a, b) => {
              if(a < b) { return -1; }
              if(a > b) { return 1; }
              return 0;
          });
          ftypes.unshift("All");
          setSpaceTypes(ftypes);
          cats = cats.sort();
          setSpaceCats(cats);
          loadDialogBlocks(
            selectedSpaceType,
            selectedSpaceFloor,
            selectedSpaceCat,
            res["results"]
          );

          setLoading(false);
        } else {
          setLoading(false);
          alert("Error retrieving dasboard data.");
        }
      })
      .catch((err) => {
        console.log("dashboard err", err);
        setLoading(false);
      });
    // const panel = document.querySelector('.dashboard');
    // enableItemReorder(panel);
  };

  const intervalTimer = () => {
    console.log("dashboard setInterval running...");
    console.log("Pause Set Interval: ", pauseSetInternval.current);
    if (pauseSetInternval.current == false) {
      loadDashboardData();
      console.log("Ran set interval...");
    } else {
      console.log("Paused set interval...");
    }
  };

  useEffect(() => {
    if (props.AuthLoggedIn === false) {
      return;
    }
    console.log("refresh_interval: ", AuthDetail.refresh_interval * 60 * 1000);
    loadDashboardData();
    dashboardInterval = setInterval(
      intervalTimer,
      AuthDetail.refresh_interval * 60 * 1000
    );

    return () => {
      setLoading(false);
      clearInterval(dashboardInterval);
    };
  }, []);

  useEffect(() => {
    if (!isInitialRender.current && shouldUpdateSettings.current) {
      api
        .post(
          SET_DASHBOARD_SETTING,
          JSON.stringify({ settings: dashConfig, site_id: getCurrentSite() }),
          CSRFToken
        )
        .then((res) => {
          console.log("Dashboard settings update: ", res);
          let copiedMainData = tileMainData;
          copiedMainData["dashboard_settings"] = res["results"];
          setTileMainData(copiedMainData);

          shouldUpdateSettings.current = false;
        })
        .catch((err) => {
          console.log("Dashboard settings update err", err);
          shouldUpdateSettings.current = false;
        });
    }
  }, [dashConfig]);

  useEffect(() => {
    console.log("useEffect ==> ", tiles);

    let tmp = splitArr(tiles);
    setColA(tmp["arr"][0]);
    setColB(tmp["arr"][1]);
    setColC(tmp["arr"][2]);
    setBlankShouldBeHere(tmp["count"]);

    // const panel = document.querySelector('.dashboard');
    // enableItemReorder(panel);
  }, [tiles]);

  const [showLiveValueModal, setShowLiveValueModal] = useState(false);
  const [showLiveType, setShowLiveType] = useState("");

  const showMoreIconClicked = (event) => {
    event.preventDefault();
    console.log("showMoreIconClicked: ", event.target);

    let choice = event.target.getAttribute("data-type");

    if (choice === "water") {
      setShowLiveType("water");
    } else {
      setShowLiveType("cooling");
    }
    setShowLiveValueModal(true);
  };

  /* 
    Methods for Kaer Air Dialog
  */

  const spaceCatClicked = (event) => {
    console.log("=== spaceCatClicked === ", event.target.nextSibling.innerHTML);

    let floors = ["All"];
    let types = [];

    Object.keys(tileMainData["live_ka"]["room_map"]).forEach(function (key) {
      if (key == event.target.nextSibling.innerHTML) {
        Object.keys(tileMainData["live_ka"]["room_map"][key]).forEach(function (
          key1
        ) {
          types.push(key1);
          Object.keys(tileMainData["live_ka"]["room_map"][key][key1]).forEach(
            function (key2) {
              floors.push(key2);
            }
          );
        });
      }
    });

    floors.sort(
      (a, b) =>
        tileMainData["live_ka"]["floor_list"].indexOf(a) -
        tileMainData["live_ka"]["floor_list"].indexOf(b)
    );
    floors = floors.filter(onlyUnique);
    console.log("spaceCatClicked types: ", types);
    types = types.sort((a, b) => {
        if(a < b) { return -1; }
        if(a > b) { return 1; }
        return 0;
    });
    types.unshift("All");
    setSpaceTypes(types);
    console.log("spaceCatClicked floors: ", floors);
    setSpaceFloors(floors);
    setSelectedSpaceType("All");
    setSelectedSpaceFloor("All");

    setSelectedSpaceCat(event.target.nextSibling.innerHTML);
    console.log(
      "spaceCatClicked catetory: ",
      event.target.nextSibling.innerHTML
    );
    // loadDashboardData();
  };

  const spaceFloorClicked = (event) => {
    console.log("=== spaceFloorClicked === ", event.target.innerHTML);
    setSelectedSpaceFloor(event.target.innerHTML);
  };

  const spaceFloorPagingClicked = () => {
    let ind = spaceFloors.indexOf(selectedSpaceFloor);
    if (ind === spaceFloors.length - 1) {
      setSelectedSpaceFloor(spaceFloors[0]);
      console.log("=== spaceFloorPagingClicked === ", spaceFloors[0]);
    } else {
      setSelectedSpaceFloor(spaceFloors[ind + 1]);
      console.log("=== spaceFloorPagingClicked === ", spaceFloors[ind + 1]);
    }
  };

  const addSpaceBlkMouseHover = (event) => {
    let clicked = event.target.getAttribute("data-id");

    if (clicked) {
      setSelectedBlock(clicked);
    }
  };

  const addSpaceBlkMouseLeave = (event) => {
    setSelectedBlock("");
  };

  const spaceBlkClicked = (event) => {
    console.log("=== spaceBlkClicked ===");
    if (event.target.classList.contains("space-floor-blk")) {
      if (event.target.classList.contains("disabled")) {
        return;
      }
    } else {
      let tmp = event.target.closest(".space-floor-blk");
      if (tmp.classList.contains("disabled")) {
        return;
      }
    }

    let copyLiveData = { ...liveData };
    isInitialRender.current = false;
    shouldUpdateSettings.current = true;

    if (airDialogClickedFrom == "live-main") {
      copyLiveData["rooms"].forEach(function (item, index) {
        if (item["name"] == selectedBlock) {
          copyLiveData["chosen_room"] = selectedBlock;
          copyLiveData["confer_temp"] = item["temperature"];
          copyLiveData["water"] = item["humidity"];
        }
      });

      let tmpDashConfig = dashConfig.slice();
      tmpDashConfig[0]["selected"] = selectedBlock;
      setDashConfig(tmpDashConfig);

      setLiveData(copyLiveData);
    } else {
      let live_data = {
        power: "-",
        temp: 0,
        cooling: 0,
        min_cooling: 150,
        max_cooling: 2200,
        confer_temp: 0,
        water: 0,
      };

      if (tileMainData["live_kw"] && tileMainData["live_ka"]) {
        live_data["power"] = tileMainData["live_kw"]["system_status"];
        live_data["temp"] = tileMainData["live_kw"]["water_temp"];
        live_data["cooling"] = tileMainData["live_kw"]["cooling_amount"];
        live_data["rooms"] = [];
        live_data["confer_temp"] = "-";
        live_data["water"] = "-";
        live_data["chosen_room"] = "-";
      }

      if (tileMainData["live_ka"]["rooms"].length > 0) {
        live_data["rooms"] = tileMainData["live_ka"]["rooms"];
        tileMainData["live_ka"]["rooms"].forEach(function (item, index) {
          if (item["name"] == selectedBlock) {
            live_data["chosen_room"] = selectedBlock;
            live_data["confer_temp"] = item["temperature"];
            live_data["water"] = item["humidity"];
          }
        });
      }

      let tmpTiles = tiles.slice();
      let pointer = 0;

      tmpTiles.forEach(function (item, index) {
        if (item["id"] == airDialogWidget) {
          tmpTiles[index]["data"] = live_data;
          // tmpTiles[index]["selected"] = selectedBlock;
          // React render will reflect updated fields; avoid direct DOM manipulation
          pointer = index;
        }
      });

      pointer = pointer + 1;

      let tmpDashConfig = dashConfig.slice();
      tmpDashConfig[pointer]["selected"] = selectedBlock;
      setDashConfig(tmpDashConfig);

      setTiles(tmpTiles);
      let tmp = splitArr(tmpTiles);
      setColA(tmp["arr"][0]);
      setColB(tmp["arr"][1]);
      setColC(tmp["arr"][2]);
      setBlankShouldBeHere(tmp["count"]);
    }

    document.getElementById("btnMain0").click();
    setShowSpaceDialog(false);
    pauseSetInternval.current = false;
    console.log(
      "spaceBlkClicked pauseSetInternval ==> ",
      pauseSetInternval.current
    );
  };

  const spaceTypeClicked = (event) => {
    console.log("=== spaceTypeClicked === ", event.target.innerHTML);
    setSelectedSpaceType(event.target.innerHTML);

    let floors = ["All"];

    Object.keys(tileMainData["live_ka"]["room_map"]).forEach(function (key) {
      if (key == selectedSpaceCat) {
        Object.keys(tileMainData["live_ka"]["room_map"][key]).forEach(function (
          key1
        ) {
          if (
            key1 == event.target.innerHTML ||
            event.target.innerHTML == "All"
          ) {
            Object.keys(tileMainData["live_ka"]["room_map"][key][key1]).forEach(
              function (key2) {
                console.log("=== key1: ", key1, key2);
                floors.push(key2);
              }
            );
          }
        });
      }
    });

    floors = [...new Set(floors)];
    floors.sort(
      (a, b) =>
        tileMainData["live_ka"]["floor_list"].indexOf(a) -
        tileMainData["live_ka"]["floor_list"].indexOf(b)
    );
    setSpaceFloors(floors);

    setSelectedSpaceFloor("All");
  };

  const sortRooms = (a, b) => {
    const getLevelValue = (level) => {
      if (level.startsWith("B")) {
        // Return negative values for basement levels (e.g., "B1" -> -1)
        return -parseInt(level.replace("B", ""), 10);
      }
      // Return positive values for normal levels (e.g., "L1" -> 1)
      return parseInt(level.replace("L", ""), 10);
    };
    const levelA = getLevelValue(a.level_raw);
    const levelB = getLevelValue(b.level_raw);
    if (levelA === levelB) {
      return a.name.localeCompare(b.name); // Sort by name if levels are the same
    }
    return levelA - levelB; // Sort levels, with basements coming first
  };

  const [allChosenSpaces, setAllChosenSpaces] = useState([]);
  const [allChosenWaterSpaces, setAllChosenWaterSpaces] = useState([]);

  /* 
    selecting kaer air blocks based on selected type, floor & category
  */
  const loadDialogBlocks = (_type, _floor, _cat, _data) => {
    let selectedData = _data["live_ka"]["room_map"][_cat];
    let chosenData = [];

    if (!selectedData) return;

    if (_type === "All") {
      if (_floor === "All") {
        Object.keys(selectedData).forEach(function (key) {
          // console.log(key + " " + selectedData[key]);

          Object.keys(selectedData[key]).forEach(function (key2) {
            // console.log(key2 + " " + selectedData[key][key2]);

            chosenData.push(...selectedData[key][key2]);
          });
        });
      } else {
        Object.keys(selectedData).forEach(function (key) {
          if (_floor in selectedData[key]) {
            chosenData.push(...selectedData[key][_floor]);
          }
        });
      }
    } else {
      if (_floor === "All") {
        if (selectedData[_type]) {
          Object.keys(selectedData[_type]).forEach(function (key2) {
            chosenData.push(...selectedData[_type][key2]);
          });
        }
      } else {
        if (selectedData[_type]) {
          if (_floor in selectedData[_type]) {
            chosenData.push(...selectedData[_type][_floor]);
          }
        }
      }
    }

    chosenData = chosenData.sort(sortRooms);
    console.log("chosenData:", chosenData);
    setSpaceBlocks(chosenData);
  };

  useEffect(() => {
    console.log("useEffect selectedSpaceType ==> ", selectedSpaceType);
    console.log("useEffect selectedSpaceFloor ==> ", selectedSpaceFloor);
    console.log("useEffect selectedSpaceCat ==> ", selectedSpaceCat);

    console.log("tileMainData ==> ", tileMainData);
    if (!isInitialRender.current) {
      loadDialogBlocks(
        selectedSpaceType,
        selectedSpaceFloor,
        selectedSpaceCat,
        tileMainData
      );
    }
  }, [selectedSpaceType, selectedSpaceFloor, selectedSpaceCat]);

  /*
    Kaer Air Space Modal
  */

  const showSpaceDialogClicked = (event) => {
    console.log("showSpaceDialogClicked:", event);
    event.preventDefault();
    loadDialogBlocks("All", "All", "Main", tileMainData);

    let widget = event.target.getAttribute("data-widget");
    let clickedId = event.target.getAttribute("data-id");

    let tmpArr = [];
    console.log(
      'tileMainData["dashboard_settings"]: ',
      tileMainData["dashboard_settings"]
    );
    if (tileMainData["dashboard_settings"]) {
      tileMainData["dashboard_settings"]["setting"].forEach((item, i) => {
        if (item["name"] == "main") {
          if (item["selected"] == "" && tileMainData["live_ka"].length > 0) {
            tmpArr.push(tileMainData["live_ka"]["rooms"][0]["name"]);
          } else {
            tmpArr.push(item["selected"]);
          }
        }
        if (item["name"] == "live") {
          tmpArr.push(item["selected"]);
        }
      });
    }
    console.log("tmpArr: ", tmpArr);
    setAllChosenSpaces(tmpArr);
    setAirDialogClickedFrom(widget);
    setShowSpaceDialog(true);
    pauseSetInternval.current = true;
    console.log(
      "showSpaceDialogClicked pauseSetInternval ==> ",
      pauseSetInternval.current
    );

    if (clickedId) {
      setAirDialogWidget(clickedId);
    }
  };

  const handleCloseSpaceDialog = (event) => {
    setSelectedBlock("");
    setSelectedSpaceType("All");
    setSelectedSpaceFloor("All");
    document.getElementById("btnMain0").click();
    setShowSpaceDialog(false);
    pauseSetInternval.current = false;
    console.log(
      "handleCloseSpaceDialog pauseSetInternval ==> ",
      pauseSetInternval.current
    );
  };

  /*
    Kaer Water Space Modal
  */
  const handleChilledWaterSupplyClicked = (event) => {
    event.preventDefault();
    console.log("handleChilledWaterSupplyClicked:", event);

    let widget = event.target.getAttribute("data-widget");
    let clickedId = event.target.getAttribute("data-id");

    let tmpArr = [];
    console.log(
      'tileMainData["dashboard_settings"]: ',
      tileMainData["dashboard_settings"]
    );

    if (tileMainData["dashboard_settings"]) {
      tileMainData["dashboard_settings"]["setting"].forEach((item, i) => {
        if (widget === "chilled-water-main") {
          if (item["name"] == "main") {
            if (!item["selected_kw"] || item["selected_kw"] == "") {
              tmpArr.push(tileMainData["live_kw_data"]["rooms"][0]["name"]);
            } else {
              tmpArr.push(item["selected_kw"]);
            }
          }
        } else {
          if (item["name"] == "chilled_water_supply") {
            tmpArr.push(item["selected"]);
          }
        }
      });
    }
    console.log("tmpArr: ", tmpArr);
    setAllChosenWaterSpaces(tmpArr);
    setWaterDialogClickedFrom(widget);
    setShowWaterSpaceDialog(true);

    pauseSetInternval.current = true;
    console.log(
      "showSpaceDialogClicked pauseSetInternval ==> ",
      pauseSetInternval.current
    );

    if (clickedId) {
      setWaterDialogWidget(clickedId);
    }
  };

  const handleCloseWaterSpaceDialog = (event) => {
    setSelectedWaterBlock("");
    // document.getElementById("btnMain0").click();
    setShowWaterSpaceDialog(false);
    pauseSetInternval.current = false;
    console.log(
      "handleCloseWaterSpaceDialog pauseSetInternval ==> ",
      pauseSetInternval.current
    );
  };

  const addWaterSpaceBlkMouseHover = (event) => {
    let clicked = event.target.getAttribute("data-id");

    if (clicked) {
      setSelectedWaterBlock(clicked);
    }
  };

  const addWaterSpaceBlkMouseLeave = (event) => {
    setSelectedWaterBlock("");
  };

  const waterSpaceBlkClicked = (event) => {
    console.log("=== waterSpaceBlkClicked ===");

    /*
      Skip if kaer water block is already disabled on the modal
    */
    if (event.target.classList.contains("space-floor-blk")) {
      if (event.target.classList.contains("disabled")) {
        return;
      }
    } else {
      let tmp = event.target.closest(".space-floor-blk");
      if (tmp.classList.contains("disabled")) {
        return;
      }
    }

    /*
      Copy the main live data json
      And dashboard settings
    */
    let copyLiveData = { ...liveData };
    let tmpDashConfig = dashConfig.slice();

    isInitialRender.current = false;
    shouldUpdateSettings.current = true;

    console.log("waterDialogClickedFrom:", waterDialogClickedFrom);
    console.log("selectedWaterBlock:", selectedWaterBlock);

    /*
      If it's clicked from the main Live Block
    */
    if (waterDialogClickedFrom == "chilled-water-main") {
      copyLiveData["kw_rooms"].forEach(function (item, index) {
        if (item["name"] == selectedWaterBlock) {
          copyLiveData["selected_kw"] = item;
        }
      });

      tmpDashConfig[0]["selected_kw"] = selectedWaterBlock;
      setDashConfig(tmpDashConfig);

      setLiveData(copyLiveData);
    } else {
      /*
        If it's clicked from the one of the widgets
      */

      let tmpTiles = tiles.slice();
      let pointer = 0;

      if (tileMainData["live_kw_data"]["rooms"].length > 0) {
        copyLiveData["kw_rooms"] = tileMainData["live_ka"]["rooms"];
        tileMainData["live_kw_data"]["rooms"].forEach(function (item, index) {
          if (item["name"] == selectedWaterBlock) {
            copyLiveData["selected_kw"] = item;
          }
        });
      }

      tmpTiles.forEach(function (item, index) {
        console.log(item, item["id"], waterDialogWidget);
        if (item["id"].toString() == waterDialogWidget) {
          tmpTiles[index]["data"] = copyLiveData;
          tmpTiles[index]["selected_kw"] = pointer = index;
        }
      });

      pointer = pointer + 1;

      let tmpDashConfig = dashConfig.slice();
      tmpDashConfig[pointer]["selected"] = selectedWaterBlock;
      console.log("tmpDashConfig:", tmpDashConfig);
      console.log("tmpTiles:", tmpTiles);
      setDashConfig(tmpDashConfig);

      setTiles(tmpTiles);
      let tmp = splitArr(tmpTiles);
      setColA(tmp["arr"][0]);
      setColB(tmp["arr"][1]);
      setColC(tmp["arr"][2]);
      setBlankShouldBeHere(tmp["count"]);
    }

    // document.getElementById("btnMain0").click();
    setShowWaterSpaceDialog(false);
    pauseSetInternval.current = false;
    console.log(
      "waterSpaceBlkClicked pauseSetInternval ==> ",
      pauseSetInternval.current
    );
  };

  return (
    <>
      {loading && <LoadingModal loading={loading} />}
      {showSpaceDialog && (
        <DashboardSpaceModal
          showSpaceDialog={showSpaceDialog}
          handleCloseSpaceDialog={handleCloseSpaceDialog}
          spaceCats={spaceCats}
          spaceCatClicked={spaceCatClicked}
          selectedSpaceCat={selectedSpaceCat}
          spaceTypes={spaceTypes}
          selectedSpaceType={selectedSpaceType}
          spaceTypeClicked={spaceTypeClicked}
          spaceFloors={spaceFloors}
          selectedSpaceFloor={selectedSpaceFloor}
          spaceFloorClicked={spaceFloorClicked}
          spaceFloorPagingClicked={spaceFloorPagingClicked}
          spaceBlocks={spaceBlocks}
          selectedBlock={selectedBlock}
          allChosenSpaces={allChosenSpaces}
          spaceBlkClicked={spaceBlkClicked}
          addSpaceBlkMouseHover={addSpaceBlkMouseHover}
          addSpaceBlkMouseLeave={addSpaceBlkMouseLeave}
        />
      )}
      {showWaterSpaceDialog && (
        <DashboardWaterModal
          title={"Select"}
          showSpaceDialog={showWaterSpaceDialog}
          handleCloseSpaceDialog={handleCloseWaterSpaceDialog}
          selectedBlock={selectedWaterBlock}
          spaceBlocks={waterSpaceBlocks}
          allChosenSpaces={allChosenWaterSpaces}
          spaceBlkClicked={waterSpaceBlkClicked}
          addSpaceBlkMouseHover={addWaterSpaceBlkMouseHover}
          addSpaceBlkMouseLeave={addWaterSpaceBlkMouseLeave}
        />
      )}
      {showTile && (
        <DashboardWidgetModal
          AuthDetail={AuthDetail}
          menuClicked={menuClicked}
          selected_tile={selected_tile}
          addTileMouseHover={addTileMouseHover}
          addTileMouseLeave={addTileMouseLeave}
          showTile={showTile}
          setShowTile={setShowTile}
          liveData={liveData}
        />
      )}
      <Row style={{ marginLeft: "1em", marginRight: "1em" }}>
        {liveData && (
          <StatsBlk
            heading="Live"
            data={liveData}
            showLiveValueModal={showLiveValueModal}
            setShowLiveValueModal={setShowLiveValueModal}
            showLiveType={showLiveType}
            setShowLiveType={setShowLiveType}
            showMoreIconClicked={showMoreIconClicked}
            showSpaceDialogClicked={showSpaceDialogClicked}
            onChilledWaterSupplyClicked={handleChilledWaterSupplyClicked}
            hideKaerAir={!liveData.show_space_temp}
          />
        )}
      </Row>
      <Row
        className="pt-2 ps-4 pe-0 dashboard d-none d-lg-inline-flex"
        onDragStart={dashboardDragStart}
        onDragOver={dashboardDragOver}
        onDrop={dashboardDrop}
        onDragEnd={dashboardDragEnd}
      >
        <Col lg="4" md="12" data-col="colA">
          {colA.length > 0 ? (
            colA.map((_, index) => {
              return (
                <DashboardBlk
                  id={_.id}
                  tile_type={_.tile_type}
                  tile_heading={_.tile_heading}
                  chart_type={_.chart_type}
                  chart_title={_.chart_title}
                  data={_.data}
                  chosen_date={_.chosen_date}
                  chosen_type={_.chosen_type}
                  chosen_text={_.chosen_text}
                  dataChoiceClicked={dataChoiceClicked}
                  removeWidgetClicked={removeWidgetClicked}
                  readNotification={readNotification}
                  all_available_resource_types={all_available_resource_types}
                  resoChoiceClicked={resoChoiceClicked}
                  showSpaceDialogClicked={showSpaceDialogClicked}
                  showWaterSpaceDialogClicked={handleChilledWaterSupplyClicked}
                  selected={_.selected}
                />
              );
            })
          ) : (
            <div></div>
          )}
          {blankShouldBeHere === 0 && (
            <div style={{ padding: "5px" }}>
              <BlankBlk handleShow={handleShow} />
            </div>
          )}
        </Col>
        <Col lg="4" md="12" data-col="colB">
          {colB.length > 0 ? (
            colB.map((_, index) => {
              return (
                <DashboardBlk
                  id={_.id}
                  tile_type={_.tile_type}
                  tile_heading={_.tile_heading}
                  chart_type={_.chart_type}
                  chart_title={_.chart_title}
                  data={_.data}
                  chosen_date={_.chosen_date}
                  chosen_type={_.chosen_type}
                  chosen_text={_.chosen_text}
                  dataChoiceClicked={dataChoiceClicked}
                  removeWidgetClicked={removeWidgetClicked}
                  readNotification={readNotification}
                  all_available_resource_types={all_available_resource_types}
                  resoChoiceClicked={resoChoiceClicked}
                  showSpaceDialogClicked={showSpaceDialogClicked}
                  showWaterSpaceDialogClicked={handleChilledWaterSupplyClicked}
                  selected={_.selected}
                />
              );
            })
          ) : (
            <div></div>
          )}
          {blankShouldBeHere === 1 && (
            <div style={{ padding: "5px" }}>
              <BlankBlk
                handleShow={handleShow}
                key={Math.floor(Math.random() * 1000 + 1)}
              />
            </div>
          )}
        </Col>
        <Col lg="4" md="12" data-col="colC">
          {colC.length > 0 ? (
            colC.map((_, index) => {
              return (
                <DashboardBlk
                  id={_.id}
                  tile_type={_.tile_type}
                  tile_heading={_.tile_heading}
                  chart_type={_.chart_type}
                  chart_title={_.chart_title}
                  data={_.data}
                  chosen_date={_.chosen_date}
                  chosen_type={_.chosen_type}
                  chosen_text={_.chosen_text}
                  dataChoiceClicked={dataChoiceClicked}
                  removeWidgetClicked={removeWidgetClicked}
                  readNotification={readNotification}
                  all_available_resource_types={all_available_resource_types}
                  resoChoiceClicked={resoChoiceClicked}
                  showSpaceDialogClicked={showSpaceDialogClicked}
                  showWaterSpaceDialogClicked={handleChilledWaterSupplyClicked}
                  selected={_.selected}
                />
              );
            })
          ) : (
            <div></div>
          )}
          {blankShouldBeHere === 2 && (
            <div style={{ padding: "5px" }}>
              <BlankBlk
                handleShow={handleShow}
                key={Math.floor(Math.random() * 1000 + 1)}
              />
            </div>
          )}
        </Col>
      </Row>
      <Row
        className="pt-2 dashboard d-flex d-lg-none"
        style={{ paddingLeft: "2.1em", paddingRight: "0.2em" }}
      >
        {tiles.length > 0 ? (
          tiles.map((_, index) => {
            return (
              <DashboardBlk
                id={_.id}
                tile_type={_.tile_type}
                tile_heading={_.tile_heading}
                chart_type={_.chart_type}
                chart_title={_.chart_title}
                data={_.data}
                chosen_date={_.chosen_date}
                chosen_type={_.chosen_type}
                chosen_text={_.chosen_text}
                dataChoiceClicked={dataChoiceClicked}
                removeWidgetClicked={removeWidgetClicked}
                readNotification={readNotification}
                all_available_resource_types={all_available_resource_types}
                resoChoiceClicked={resoChoiceClicked}
                showSpaceDialogClicked={showSpaceDialogClicked}
                showWaterSpaceDialogClicked={handleChilledWaterSupplyClicked}
                selected={_.selected}
              />
            );
          })
        ) : (
          <div></div>
        )}
      </Row>
      <Row className="extra-blank d-block d-lg-none">
        <BlankBlk
          handleShow={handleShow}
          key={Math.floor(Math.random() * 1000 + 1)}
        />
      </Row>
    </>
  );
}

const mapStateToProps = (state) => ({
  AuthDetail: state.loginUserDetail.userDetail,
  AuthLoggedIn: state.loginUserDetail.loggedIn,
  CSRFToken: state.loginUserDetail.csrf,
});

const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
